import { sortAscending } from '../helpers/sort';

const requestSdmType = 'REQUEST_SDM';
const receiveSdmType = 'RECEIVE_SDM';

const requestNonSdmType = 'REQUEST_NON_SDM';
const receiveNonSdmType = 'RECEIVE_NON_SDM';
const initialState = {
    all: [],
    allNonSdms: [],

    withCaseTracking: [],
    withoutCaseTracking: [],

    withMonitoring: [],
    withoutMonitoring: [],

    withNameSearch: [],
    withoutNameSearch: [],

    withTwoPartSearch: [],
    withoutTwoPartSearch: [],

    isLoading: false
};



export const actionCreators = {
    requestSdms: () => async (dispatch, getState) => {

        if (getState().scraperDefinitionModels.all.length > 0 || getState().scraperDefinitionModels.isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: requestSdmType });

        const url = `api/Sdm/GetSdms`;
        const response = await fetch(url);
        const all = await response.json();

        all.sort(sortAscending("scraperName"));

        //let withCaseTracking = all.filter(item => item.hasCaseTracking && item.dataSourceType === 'Court' );
        //let withoutCaseTracking = all.filter(item => !item.hasCaseTracking && item.dataSourceType === 'Court');
        //let withMonitoring = all.filter(item => item.hasMonitoring/* && item.dataSourceType === 'Court'*/);
        //let withoutMonitoring = all.filter(item => !item.hasMonitoring/* && item.dataSourceType === 'Court'*/);
        //let withNameSearch = all.filter(item => item.hasNameSearch && item.dataSourceType === 'Court');
        //let withoutNameSearch = all.filter(item => !item.hasNameSearch && item.dataSourceType === 'Court');
        //let withTwoPartSearch = all.filter(item => item.hasTwoPartSearch);
        //let withoutTwoPartSearch = all.filter(item => !item.hasTwoPartSearch);

        //let withSaveToDB = all.filter(item => item.setupToSaveInHistoricalDB);
        //let withoutSaveToDB = all.filter(item => !item.setupToSaveInHistoricalDB);

        let courts = all.filter(item => item.dataSourceType === 'Court');
        let sexOffenderRegistries = all.filter(item => item.dataSourceType === 'SexOffenderRegistry');
        let arrests = all.filter(item => item.dataSourceType === 'Arrest');
            
        dispatch({
            type: receiveSdmType,
            data: {
                all,

                //withCaseTracking,
                //withoutCaseTracking,

                //withMonitoring,
                //withoutMonitoring,

                //withNameSearch,
                //withoutNameSearch,

                //withTwoPartSearch,
                //withoutTwoPartSearch,

                //withSaveToDB,
                //withoutSaveToDB,

                courts,
                sexOffenderRegistries,
                arrests
            }
        });
    },
    requestNonSdms: () => async (dispatch, getState) => {

        if (getState().scraperDefinitionModels.allNonSdms.length > 0 || getState().scraperDefinitionModels.isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: requestSdmType });

        const url = `api/Sdm/GetNonSdms`;
        const response = await fetch(url);
        const allNonSdms = await response.json();

        allNonSdms.sort(sortAscending("scraperName"));

        dispatch({
            type: receiveNonSdmType,
            data: {
                allNonSdms
            }
        });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestSdmType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveSdmType) {
        return {
            ...state,
            ...action.data,
            isLoading: false
        };
    }

    if (action.type === requestNonSdmType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveNonSdmType) {
        return {
            ...state,
            ...action.data,
            isLoading: false
        };
    }

    return state;
};
